import React from 'react';
import { FaTimes } from 'react-icons/fa';
import './Header.css';

const PlatformModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handlePlatformSelect = (url) => {
    window.open(url, '_blank');
    onClose();
  };

  return (
    <div className="platform-modal-overlay" onClick={onClose}>
      <div className="platform-modal" onClick={(e) => e.stopPropagation()}>
        <div className="platform-modal-header">
          <h3>Escolha a Plataforma</h3>
          <button 
            className="platform-modal-close"
            onClick={onClose}
          >
            <FaTimes />
          </button>
        </div>
        <div className="platform-modal-content">
          <button 
            className="platform-option-btn"
            onClick={() => handlePlatformSelect('https://cloud.autonav.com.br/')}
          >
            <div className="platform-icon-large">☁️</div>
            <div className="platform-info">
              <h4>1. AutoNav Cloud</h4>
              <p>Sistema de monitoramento</p>
            </div>
          </button>
          <button 
            className="platform-option-btn"
            onClick={() => handlePlatformSelect('https://autonav.com.br/track/')}
          >
            <div className="platform-icon-large">📍</div>
            <div className="platform-info">
              <h4>2. AutoNav Track</h4>
              <p>Sistema de monitoramento</p>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlatformModal;

